<template>
	<button class="button" @click="click">
		<slot></slot>
	</button>
</template>

<script>
//	import soundFx from '@/mixins/sound-fx';

export default {
	//	mixins: [soundFx],
	props: {
		action: {
			type: Function,
			required: true,
		},
	},
	methods: {
		click() {
			//	this.playRandomSound("clicks");
			this.action();
		},
	},
};
</script>

<style lang="scss" scoped>
	.button {
		display: block;
		padding: 0.25em 1.5em;
		margin: 20px auto;
		font-family: $body-font-stack;
		font-size: 1.125em;
		letter-spacing: .07em;
		text-transform: uppercase;
		color: black;
		border-top: 5px solid #808080;
		border-left: 5px solid #808080;
		border-bottom: 5px solid black;
		border-right: 5px solid black;
		cursor: pointer;
		background: #c3c2c2;
		transition: all $ui-transition-duration;
		&:hover,
		&:focus {
			color: $red;
			outline: 0;
			border-top-color: black;
			border-left-color: black;
			border-bottom-color: #808080;
			border-right-color: #808080;
		}
		&:active {
			border-bottom-color: #808080;
			border-right-color: #808080;
			border-top-color: black;
			border-left-color: black;
			outline: 0;
		}
		@include breakpoint(lg) {
			font-size: 1.06em;
			border-width: 5px;
			margin: 15px auto;
		}
		@include breakpoint(md) {
			font-size: 1em;
			border-width: 4px;
			margin: 15px auto;
		}
		@include breakpoint(sm) {
			font-size: 0.875em;
			border-width: 3px;
			margin: 10px auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Button.vue